import { useEffect } from 'react'

import { flushTelemetry } from 'modules/miniapp'

/**
 * Releases analytics buffered during bootstrap.
 *
 * Rendered inside <PostHogProvider>, so by the time this effect runs PostHog
 * has been initialised and the queued launch event and super-properties can
 * actually be sent. Without this they were captured before init() and silently
 * dropped — which is why `miniapp_launch` never appeared and `miniapp_platform`
 * was empty on every event.
 *
 * Renders nothing.
 */
export default function TelemetryFlusher() {
    useEffect(() => {
        flushTelemetry()
    }, [])
    return null
}
